module.exports = __webpack_public_path__ + "img/K-coin-grey.5c6418a.png";